/* eslint-disable no-case-declarations */
import {
  DELETE_SUCCESS,
  RESET,
  SET_TOOLS,
  RESET_TOOLS,
} from './actionTypes';

const initialState = {
  tools: [],
  deleted: false,
};

const toolbar = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOOLS:
      const { tools } = action.payload;
      return {
        ...state,
        tools: _.sortBy(tools, ['sequence']),
      };

    case RESET_TOOLS:
      return {
        ...state,
        tools: initialState.tools
      }

    case DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
      };


    case RESET:
      return initialState;


    default:
      return state;
  }
};

export default toolbar;



// WEBPACK FOOTER //
// ./src/components/page/DetailsToolbar/flow/reducer.js